var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bs-docs-section",attrs:{"id":_vm.id}},[_c('h1',{staticClass:"page-header"},[_c('a',{staticClass:"anchor",attrs:{"href":'#' + _vm.id},on:{"click":function($event){$event.preventDefault();}}},[_vm._v(_vm._s(_vm.name))])]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8233d6d6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/example/utils/docSection.vue
// module id = 421
// module chunks = 0